import React from "react";
import Script from "react-load-script";
import graphql from "graphql";
import styled from "styled-components";

import Hero from "../components/Hero";
import Intro from "../components/Intro/Intro";
import Proof from "../components/Proof";
import Stats from "../components/Stats";
import Connect from "../components/Connect";

export type metaDataProps = {
  siteMetadata: {
    appUrl: string
  }
};

type Props = {
  data: {
    ...metaDataProps
  }
};

export default class IndexPage extends React.Component<Props> {
  handleScriptLoad() {
    if (typeof window !== `undefined` && window.netlifyIdentity) {
      window.netlifyIdentity.on("init", user => {
        if (!user) {
          window.netlifyIdentity.on("login", () => {
            document.location.href = "/admin/";
          });
        }
      });
    }
    window.netlifyIdentity.init();
  }

  render() {
    const { data } = this.props;
    const { siteMetadata } = data.site;

    return (
      <div>
        {/* <Script
          url="https://identity.netlify.com/v1/netlify-identity-widget.js"
          onLoad={() => this.handleScriptLoad()}
        /> */}

        <Wrap>
          <Hero siteMetadata={siteMetadata} pt={[2, 2, 5]} />

          <Intro mb={[5, 5, 6]} siteMetadata={siteMetadata} />

          <Proof siteMetadata={siteMetadata} mb={[5, 5, 6]} />

          <Stats py={["80px"]} mb={["80px"]} siteMetadata={siteMetadata} />

          <Connect mb={[5, 5, 6]} pt={[5]} />
        </Wrap>
      </div>
    );
  }
}

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        appUrl
      }
    }
  }
`;

const Wrap = styled.div`
  position: relative;
  z-index: 1;
`;



// WEBPACK FOOTER //
// ./src/pages/index.js